enum NavUserProfilePage {
  INFORMATIONS = '1',
  CREDENTIALS = '2'
}

export default NavUserProfilePage;
